import {Component, Input, ViewChild,ElementRef,Output,EventEmitter} from '@angular/core';
import { NgbModal,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector:'select-modal',
    template:`
    <div>
    ColumnID: {{column_id}}
  
  <button class="btn btn-lg btn-outline-primary" (click)="open(content)">Launch demo modal</button>

  <button class="btn btn-lg btn-outline-primary" (click)="data(content)">Show Values</button>
  
  <hr>
  
  <pre>{{closeResult}}</pre>

    </div>
    `
})

export class SelectModal{
    @Input() column_id;
    @ViewChild('modal') modal: ElementRef;

    @Output() onCreated: EventEmitter<void> = new EventEmitter<void>();
    @Output() selectValue: EventEmitter<any> = new EventEmitter();

    public open(){
        alert('Working Select Modal')
    }

    public data(){
        this.selectValue.emit('new Value')
    }

    constructor(
            public modalService:NgbModal,
            public activeModal: NgbActiveModal
            ){

            }
}
